import React from 'react';
import { Card as MuiCard, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { SiteFinityContentTypes, CMSContent } from './data/CMSContent';

interface CardProps {
  page: string;
  type?: SiteFinityContentTypes;
  name?: string;
  classes: any;
}
const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1em;
`;

const CardContentWrapper = styled.div`
  height: 100%;
  overflow: hidden;
`;

const Card: React.FC<CardProps> = ({ page, type, name, classes }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/${page}`);
  };

  return (
    <MuiCard className={classes.card} onClick={handleClick}>
      <CardContent className={classes.cardContent}>
        <CardContentWrapper>
          <Typography className={classes.cardTitle} variant="h3" component="h3">
            {page.toUpperCase()}
          </Typography>
          <CMSContent type={type} name={name} />
        </CardContentWrapper>
        <ReadMoreWrapper>
          <p>Read More &gt;</p>
        </ReadMoreWrapper>
      </CardContent>
    </MuiCard>
  );
};

export default Card;
